import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AiOutlineArrowDown, AiOutlineArrowUp } from 'react-icons/ai';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import FileSaver from 'file-saver';
import * as Yup from 'yup';

import { ReactComponent as CleanIcon } from '../../../../assets/icons/ubr_clean.svg';
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/ubr_download.svg';
import { ReactComponent as FilterIcon } from '../../../../assets/icons/ubr_filter.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/icons/ubr_search.svg';
import {
  Button,
  Input,
  Pagination,
  Select,
  Shimmer,
} from '../../../../components';
import api from '../../../../services/api';
import { EndpointsAPI } from '../../../../services/Endpoints';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { statusOptions } from './status';
import {
  ActionsForm,
  Badge,
  Container,
  FooterTable,
  InputGroup,
  LoadingData,
  OrderContainer,
  TableContainer,
} from './styles';

export enum StatusType {
  Default = 'DEFAULT',
  Pendente = 'PENDENTE',
  Processando = 'PROCESSANDO',
  Sucesso = 'SUCESSO',
  Erro = 'ERRO',
}
interface SearchProps {
  identificadorEmpresa: string | undefined;
  status: StatusType | undefined;
}

// interface DataProps {
//   dataLogin: string;
//   dataPrimeiraOperacao: string;
//   dataUltimaOperacao: string;
//   status: StatusType;
//   identificadorEmpresa: string;
//   key: string;
//   dataUltimaHomologacao: string;
// }

const RelatorioSintetico: React.FC = () => {
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [itemsPerPage, setitemsPerPage] = useState<number>(5);
  const [order, setOrder] = useState<boolean>();
  const [filter, setFilter] = useState<any>({
    identificadorEmpresa: null,
    dataInicio: null,
    dataFim: null,
    periodo: null,
    paginacao: {
      direcao: !order ? 'ASC' : 'DESC',
      numeroPagina: currentPage,
      tamanhoPagina: itemsPerPage,
    },
    produto: 'CONVENIOS',
  });
  const formRef = useRef<FormHandles | null>(null);
  const homologData = useRef<any>();
  let selectedStatus = useRef<any>();

  function formatDate(data: string) {
    if (!data) {
      return 'N/D';
    }
    let dateLocal = new Date(data);
    return (
      dateLocal.toLocaleDateString() + ' ' + dateLocal.toLocaleTimeString()
    );
  }

  // Renderizar a tabela

  const loadingTable = () => {
    return (
      <tr>
        <td>
          <p
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </p>
        </td>
        <td>
          <p
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </p>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
      </tr>
    );
  };

  const renderData = () => {
    return (
      <TableContainer>
        <table id="tableData">
          <thead>
            <tr>
              <th style={{ width: '160px' }}>
                <OrderContainer>
                  Parceiro
                  {order ? (
                    <button onClick={() => setOrder(false)}>
                      <AiOutlineArrowUp />
                    </button>
                  ) : (
                    <button onClick={() => setOrder(true)}>
                      <AiOutlineArrowDown />
                    </button>
                  )}
                </OrderContainer>
              </th>

              <th style={{ width: '140px' }}>
                Data do Primeiro Login Parceiro
              </th>
              <th style={{ width: '140px' }}>Data do Inicio da Operação</th>
              <th style={{ width: '140px' }}>Ultima Data Operação</th>
              <th style={{ width: '140px' }}>Data da Ultima Homologação</th>
              <th style={{ width: '140px' }}>Ultimo Status do Processo</th>
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              {loadingTable()}
              {loadingTable()}
              {loadingTable()}
            </tbody>
          ) : !data!?.content.length ? (
            <LoadingData> Sem dados para exibir... </LoadingData>
          ) : (
            <tbody>
              {data!?.content!?.map((todo: any, index: number) => (
                <tr key={index}>
                  <td data-column="Identificador">
                    {todo.identificadorEmpresa}
                  </td>

                  <td data-column="Data do Primeiro Login cooperado">
                    {formatDate(todo.dataLogin)}
                  </td>
                  <td data-column="Data do inicio da operação">
                    {formatDate(todo.dataPrimeiraOperacao)}
                  </td>
                  <td data-column="Ultima Data da Operacao">
                    {formatDate(todo.dataUltimaOperacao)}
                  </td>
                  <td data-column="Data da Ultima Homologação">
                    {formatDate(todo.dataUltimaHomologacao)}
                  </td>
                  <td data-column="Ultimo Status do Processo">
                    <Badge type={todo.status}>{todo.status}</Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </TableContainer>
    );
  };

  // Funções para realização da paginação

  // Data

  const fetchData = useCallback(
    async (search: any) => {
      formRef.current?.setErrors({});
      setIsLoading(true);
      try {
        const response = await api.post('convenio/relatorios/sintetico', search);
        setData(response.data);
        setIsLoading(false);
      } catch (e) {
        console.error(e);
      }
    },
    [filter, itemsPerPage, currentPage, order],
  );

  useEffect(() => {
    fetchData({
      ...filter,
      paginacao: {
        direcao: !order ? 'ASC' : 'DESC',
        numeroPagina: currentPage,
        tamanhoPagina: itemsPerPage,
      },
    });
  }, [currentPage, itemsPerPage, order]);

  const handleFilter = useCallback(
    async (dataFilter: SearchProps) => {
      let filteredData = homologData.current;

      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          identificadorEmpresa: Yup.string().required(
            'Este campo é obrigatório!',
          ),
        });

        await schema.validate(dataFilter, {
          abortEarly: false,
        });

        if (dataFilter.status) {
          filteredData = filteredData.filter(
            (item: any) => item.status === dataFilter.status,
          );
        }
        if (dataFilter.identificadorEmpresa) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          filteredData = filteredData.filter(
            (item: any) =>
              item.identificadorEmpresa === dataFilter.identificadorEmpresa,
          );
        }

        setFilter({
          identificadorEmpresa: data.identificadorEmpresa
            ? data.identificadorEmpresa
            : null,
          dataInicio: data.dataInicio ? data.dataInicio : null,
          dataFim: data.dataFim ? data.dataFim : null,
          periodo: data.periodo ? data.periodo : null,
          paginacao: {
            direcao: !order ? 'ASC' : 'DESC',
            numeroPagina: currentPage,
            tamanhoPagina: itemsPerPage,
          },
          produto: 'CONVENIOS',
        });

        fetchData({
          identificadorEmpresa: data.identificadorEmpresa
            ? data.identificadorEmpresa
            : null,
          dataInicio: data.dataInicio ? data.dataInicio : null,
          dataFim: data.dataFim ? data.dataFim : null,
          periodo: data.periodo ? data.periodo : null,
          paginacao: {
            direcao: !order ? 'ASC' : 'DESC',
            numeroPagina: currentPage,
            tamanhoPagina: itemsPerPage,
          },
          produto: 'CONVENIOS',
        });

        //   identificadorEmpresa: null,
        // dataInicio: null,
        // dataFim: null,
        // periodo: null,
        // paginacao: {
        //   direcao: !order ? 'ASC' : 'DESC',
        //   numeroPagina: currentPage,
        //   tamanhoPagina: itemsPerPage,
        // },
        // produto: 'CONVENIOS',
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errorMessages = getValidationErrors(err);
          formRef.current?.setErrors(errorMessages);
          return;
        }
      }
    },
    [filter],
  );

  const onClear = () => {
    formRef.current?.reset();

    const select = formRef!.current!.getFieldRef('status');
    select.select.clearValue();

    fetchData({
      identificadorEmpresa: null,
      dataInicio: null,
      dataFim: null,
      periodo: null,
      paginacao: {
        direcao: !order ? 'ASC' : 'DESC',
        numeroPagina: 0,
        tamanhoPagina: itemsPerPage,
      },
      produto: 'CONVENIOS',
    });
  };

  const relatoryDownload = async () => {
    const response = await api.post(
      'convenio/relatorios/sintetico/completo',
      filter,
      {
        responseType: 'arraybuffer',
      },
    );

    const url = URL.createObjectURL(
      new Blob(['\ufeff', response.data], {
        type: 'text/csv;charset=utf-8',
      }),
    );

    FileSaver.saveAs(
      url,
      'relatorio_de_atividades_' + new Date().getTime() + '.csv',
    );
  };

  return (
    <Container>
      <Form className="form-container" ref={formRef} onSubmit={handleFilter}>
        <FilterIcon width={28} />
        <InputGroup>
          <Input
            name="identificadorEmpresa"
            label="Identificador Parceiro"
            type="text"
            mask={'identificadorParceiro'}
            placeholder="Ex.: 13600000000000000000"
            style={{ width: 250 }}
          />

          <div className="select-field">
            <Select
              name={'status'}
              isMulti={false}
              options={statusOptions}
              onChange={option => (selectedStatus.current = option.value)}
              placeholder="Selecione"
              label="Status"
              loading={!statusOptions.length ? true : false}
            />
          </div>
        </InputGroup>
        <ActionsForm>
          <div>
            <Button
              variant="solid-icon"
              type={'submit'}
              style={{ marginRight: '1rem' }}
              tooltipText={'Pesquisar'}
            >
              <SearchIcon style={{ width: '26px' }} />
            </Button>
            <Button
              variant="solid-icon"
              type={'reset'}
              onClick={onClear}
              tooltipText={'Limpar Campos'}
            >
              <CleanIcon style={{ width: '26px' }} />
            </Button>
          </div>
          <Button
            onClick={() => relatoryDownload()}
            variant={'solid-icon'}
            tooltipText={'Baixar Relatório'}
            style={{ width: '24px' }}
          >
            <DownloadIcon />
          </Button>
        </ActionsForm>
      </Form>
      {renderData()}
      <FooterTable>
        <Pagination
          pageCount={data.totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={data.size}
          forcePage={currentPage}
          onPageChange={(pageNumber: any) => {
            setCurrentPage(pageNumber.selected);
          }}
          onPageSize={(pageSize: any) => {
            setCurrentPage(0);
            setitemsPerPage(pageSize.value);
          }}
        />
      </FooterTable>
    </Container>
  );
};

export default RelatorioSintetico;
